import { render, staticRenderFns } from "./HomeLinkBtns.vue?vue&type=template&id=5d4169a7"
import script from "./HomeLinkBtns.vue?vue&type=script&lang=js"
export * from "./HomeLinkBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports